import { Avatar, Card, CardContent, Grid, Typography, CircularProgress, CardActions, Box } from '@mui/material';

const StatCard = ({
    title,
    value,
    icon,
    loading,
    color,
    cardActions,
    cardInfo,
    currency,
    ...props

}) => {

    let formatter = Intl.NumberFormat('en');

    return (
        <Card 
        {...props} sx={{ height: '100%' }}>
            <CardContent 
            sx={{
                "&:last-child": {
                    paddingBottom: "12px !important"
                }
            }}>
                <Grid container spacing={3} alignItems={"center"}>
                    <Grid item>
                        <Avatar sx={{ backgroundColor: color, height: { xs: 36, sm: 60 }, width: { xs: 36, sm: 60 } }} >
                            {icon}
                        </Avatar>
                    </Grid>
                    <Grid item sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        {
                            loading
                                ? <CircularProgress color="primary" size={50} />
                                :
                                <>
                                    <Typography sx={{ color: '#1E1E1E', fontSize: { xs: '12px', sm: '16px' } }} >
                                        {title}
                                    </Typography>
                                    <Typography sx={{ color: '#1E1E1E', fontSize: { xs: '24px', sm: '36px' }, fontWeight: 600, mt: -1 }} >
                                        {`${formatter.format(value)} ${currency}`}
                                    </Typography>
                                </>
                        }
                    </Grid>
                </Grid>
                {!!cardInfo && 
                <Typography variant='subtitle2' fontWeight="bold" sx={{mt: 0.4}}>
                    {cardInfo}
                </Typography>
                }
                {!!cardActions &&
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {cardActions}
                    </Box>
                }
            </CardContent>
        </Card>
    )
};

export default StatCard;
